import { getCookie } from "../../../utils";
import BeEndpoints from "../../endpoints";

const guestCheckInApi = (makeRequest, filter_date = "today") => {
  const request = {
    path: `${BeEndpoints.GUEST_CHECKIN}?filter_date=${filter_date}`,
    method: "GET",
    headers: {
      AUTHORIZATION: "Token " + getCookie("user_key"),
    },
  };
  return makeRequest(request);
};

const guestListApi = (makeRequest, limit, offset, filter_date = "today") => {
  const request = {
    path: `${BeEndpoints.GUEST_LIST}?limit=${limit}&offset=${offset}&filter_date=${filter_date}`,
    method: "GET",
    headers: {
      AUTHORIZATION: "Token " + getCookie("user_key"),
    },
  };
  return makeRequest(request);
};

const guestBookingApi = (makeRequest, limit, offset) => {
  const request = {
    path: `${BeEndpoints.GUEST_BOOKING}?limit=${limit}&offset=${offset}`,
    method: "GET",
    headers: {
      AUTHORIZATION: "Token " + getCookie("user_key"),
    },
  };
  return makeRequest(request);
};

const sendOtpApi = (makeRequest, mobile) => {
  const request = {
    path: BeEndpoints.GET_OTP + "?mobile=" + mobile,
    method: "GET",
  };
  return makeRequest(request);
};

const verifyOtpApi = (makeRequest, verifyOtpData) => {
  const request = {
    path: `${BeEndpoints.VERIFY_OTP}`,
    method: "POST",
    data: verifyOtpData,
  };
  return makeRequest(request);
};

const guestCheckInSubmitApi = (makeRequest, checkInData) => {
  const request = {
    path: `${BeEndpoints.GUEST_CHECKIN}`,
    method: "POST",
    data: checkInData,
    headers: {
      AUTHORIZATION: "Token " + getCookie("user_key"),
    },
  };
  return makeRequest(request);
};

const userSignUpApi = (makeRequest, signUpUserData) => {
  const request = {
    path: `${BeEndpoints.SIGN_UP}`,
    method: "POST",
    data: signUpUserData,
  };
  return makeRequest(request);
};

export {
  guestCheckInApi,
  guestListApi,
  guestBookingApi,
  sendOtpApi,
  verifyOtpApi,
  guestCheckInSubmitApi,
  userSignUpApi,
};
